// countryLists.ts
export const COUNTRY_LIST_EN = [
  { label: 'Afghanistan (‫افغانستان‬‎)', value: 'af' },
  { label: 'Åland Islands (Åland)', value: 'ax' },
  { label: 'Albania (Shqipëri)', value: 'al' },
  { label: 'Algeria (‫الجزائر‬‎)', value: 'dz' },
  { label: 'American Samoa', value: 'as' },
  { label: 'Andorra', value: 'ad' },
  { label: 'Angola', value: 'ao' },
  { label: 'Anguilla', value: 'ai' },
  { label: 'Antarctica', value: 'aq' },
  { label: 'Antigua and Barbuda', value: 'ag' },
  { label: 'Argentina', value: 'ar' },
  { label: 'Armenia (Հայաստան)', value: 'am' },
  { label: 'Aruba', value: 'aw' },
  { label: 'Australia', value: 'au' },
  { label: 'Austria (Österreich)', value: 'at' },
  { label: 'Azerbaijan (Azərbaycan)', value: 'az' },
  { label: 'Bahamas', value: 'bs' },
  { label: 'Bahrain (‫البحرين‬‎)', value: 'bh' },
  { label: 'Bangladesh (বাংলাদেশ)', value: 'bd' },
  { label: 'Barbados', value: 'bb' },
  { label: 'Belarus (Беларусь)', value: 'by' },
  { label: 'Belgium (België)', value: 'be' },
  { label: 'Belize', value: 'bz' },
  { label: 'Benin (Bénin)', value: 'bj' },
  { label: 'Bermuda', value: 'bm' },
  { label: 'Bhutan (འབྲུག)', value: 'bt' },
  { label: 'Bolivia', value: 'bo' },
  { label: 'Bosnia and Herzegovina (BiH)', value: 'ba' },
  { label: 'Botswana', value: 'bw' },
  { label: 'Brazil (Brasil)', value: 'br' },
  { label: 'British Indian Ocean Territory', value: 'io' },
  { label: 'British Virgin Islands', value: 'vg' },
  { label: 'Brunei (Negara Brunei Darussalam)', value: 'bn' },
  { label: 'Bulgaria (България)', value: 'bg' },
  { label: 'Burkina Faso', value: 'bf' },
  { label: 'Burundi (Uburundi)', value: 'bi' },
  { label: 'Cambodia (កម្ពុជា)', value: 'kh' },
  { label: 'Cameroon (Cameroun)', value: 'cm' },
  { label: 'Canada', value: 'ca' },
  { label: 'Cape Verde (Kabu Verdi)', value: 'cv' },
  { label: 'Caribbean Netherlands', value: 'bq' },
  { label: 'Cayman Islands', value: 'ky' },
  {
    label: 'Central African Republic (République centrafricaine)',
    value: 'cf',
  },
  { label: 'Chad (Tchad)', value: 'td' },
  { label: 'Chile', value: 'cl' },
  { label: 'China (中国)', value: 'cn' },
  { label: 'Christmas Island', value: 'cx' },
  { label: 'Cocos (Keeling) Islands', value: 'cc' },
  { label: 'Colombia', value: 'co' },
  { label: 'Comoros (‫جزر القمر‬‎)', value: 'km' },
  { label: 'Congo (DRC)', value: 'cd' },
  { label: 'Congo (Republic)', value: 'cg' },
  { label: 'Cook Islands', value: 'ck' },
  { label: 'Costa Rica', value: 'cr' },
  { label: "Côte d'Ivoire", value: 'ci' },
  { label: 'Croatia (Hrvatska)', value: 'hr' },
  { label: 'Cuba', value: 'cu' },
  { label: 'Curaçao', value: 'cw' },
  { label: 'Cyprus (Κύπρος)', value: 'cy' },
  { label: 'Czech Republic (Česká republika)', value: 'cz' },
  { label: 'Denmark (Danmark)', value: 'dk' },
  { label: 'Djibouti', value: 'dj' },
  { label: 'Dominica', value: 'dm' },
  { label: 'Dominican Republic (República Dominicana)', value: 'do' },
  { label: 'Ecuador', value: 'ec' },
  { label: 'Egypt (‫مصر‬‎)', value: 'eg' },
  { label: 'El Salvador', value: 'sv' },
  { label: 'Equatorial Guinea (Guinea Ecuatorial)', value: 'gq' },
  { label: 'Eritrea', value: 'er' },
  { label: 'Estonia (Eesti)', value: 'ee' },
  { label: 'Ethiopia', value: 'et' },
  { label: 'Falkland Islands (Islas Malvinas)', value: 'fk' },
  { label: 'Faroe Islands (Føroyar)', value: 'fo' },
  { label: 'Fiji', value: 'fj' },
  { label: 'Finland (Suomi)', value: 'fi' },
  { label: 'France', value: 'fr' },
  { label: 'French Guiana (Guyane française)', value: 'gf' },
  { label: 'French Polynesia (Polynésie française)', value: 'pf' },
  { label: 'Gabon', value: 'ga' },
  { label: 'Gambia', value: 'gm' },
  { label: 'Georgia (საქართველო)', value: 'ge' },
  { label: 'Germany (Deutschland)', value: 'de' },
  { label: 'Ghana (Gaana)', value: 'gh' },
  { label: 'Gibraltar', value: 'gi' },
  { label: 'Greece (Ελλάδα)', value: 'gr' },
  { label: 'Greenland (Kalaallit Nunaat)', value: 'gl' },
  { label: 'Grenada', value: 'gd' },
  { label: 'Guadeloupe', value: 'gp' },
  { label: 'Guam', value: 'gu' },
  { label: 'Guatemala', value: 'gt' },
  { label: 'Guernsey', value: 'gg' },
  { label: 'Guinea (Guinée)', value: 'gn' },
  { label: 'Guinea-Bissau (Guiné Bissau)', value: 'gw' },
  { label: 'Guyana', value: 'gy' },
  { label: 'Haiti', value: 'ht' },
  { label: 'Honduras', value: 'hn' },
  { label: 'Hong Kong (香港)', value: 'hk' },
  { label: 'Hungary (Magyarország)', value: 'hu' },
  { label: 'Iceland (Ísland)', value: 'is' },
  { label: 'India (भारत)', value: 'in' },
  { label: 'Indonesia', value: 'id' },
  { label: 'Iran (‫ایران‬‎)', value: 'ir' },
  { label: 'Iraq (‫العراق‬‎)', value: 'iq' },
  { label: 'Ireland', value: 'ie' },
  { label: 'Isle of Man', value: 'im' },
  { label: 'Israel (‫ישראל‬‎)', value: 'il' },
  { label: 'Italy (Italia)', value: 'it' },
  { label: 'Jamaica', value: 'jm' },
  { label: 'Japan (日本)', value: 'jp' },
  { label: 'Jersey', value: 'je' },
  { label: 'Jordan (‫الأردن‬‎)', value: 'jo' },
  { label: 'Kazakhstan (Казахстан)', value: 'kz' },
  { label: 'Kenya', value: 'ke' },
  { label: 'Kiribati', value: 'ki' },
  { label: 'Kosovo (Kosovë)', value: 'xk' },
  { label: 'Kuwait (‫الكويت‬‎)', value: 'kw' },
  { label: 'Kyrgyzstan (Кыргызстан)', value: 'kg' },
  { label: 'Laos (ລາວ)', value: 'la' },
  { label: 'Latvia (Latvija)', value: 'lv' },
  { label: 'Lebanon (‫لبنان‬‎)', value: 'lb' },
  { label: 'Lesotho', value: 'ls' },
  { label: 'Liberia', value: 'lr' },
  { label: 'Libya (‫ليبيا‬‎)', value: 'ly' },
  { label: 'Liechtenstein', value: 'li' },
  { label: 'Lithuania (Lietuva)', value: 'lt' },
  { label: 'Luxembourg', value: 'lu' },
  { label: 'Macao (澳門)', value: 'mo' },
  { label: 'Macedonia (FYROM) (Македонија)', value: 'mk' },
  { label: 'Madagascar (Madagasikara)', value: 'mg' },
  { label: 'Malawi', value: 'mw' },
  { label: 'Malaysia', value: 'my' },
  { label: 'Maldives', value: 'mv' },
  { label: 'Mali', value: 'ml' },
  { label: 'Malta', value: 'mt' },
  { label: 'Marshall Islands', value: 'mh' },
  { label: 'Martinique', value: 'mq' },
  { label: 'Mauritania (‫موريتانيا‬‎)', value: 'mr' },
  { label: 'Mauritius (Moris)', value: 'mu' },
  { label: 'Mayotte', value: 'yt' },
  { label: 'Mexico (México)', value: 'mx' },
  { label: 'Micronesia', value: 'fm' },
  { label: 'Moldova (Republica Moldova)', value: 'md' },
  { label: 'Monaco', value: 'mc' },
  { label: 'Mongolia (Монгол)', value: 'mn' },
  { label: 'Montenegro (Crna Gora)', value: 'me' },
  { label: 'Montserrat', value: 'ms' },
  { label: 'Morocco (‫المغرب‬‎)', value: 'ma' },
  { label: 'Mozambique (Moçambique)', value: 'mz' },
  { label: 'Myanmar (Burma)', value: 'mm' },
  { label: 'Namibia', value: 'na' },
  { label: 'Nauru', value: 'nr' },
  { label: 'Nepal (नेपाल)', value: 'np' },
  { label: 'Netherlands (Nederland)', value: 'nl' },
  { label: 'New Caledonia (Nouvelle-Calédonie)', value: 'nc' },
  { label: 'New Zealand', value: 'nz' },
  { label: 'Nicaragua', value: 'ni' },
  { label: 'Niger (Nijar)', value: 'ne' },
  { label: 'Nigeria', value: 'ng' },
  { label: 'Niue', value: 'nu' },
  { label: 'Norfolk Island', value: 'nf' },
  { label: 'North Korea (조선 민주주의 인민 공화국)', value: 'kp' },
  { label: 'Northern Mariana Islands', value: 'mp' },
  { label: 'Norway (Norge)', value: 'no' },
  { label: 'Oman (‫عُمان‬‎)', value: 'om' },
  { label: 'Pakistan (‫پاکستان‬‎)', value: 'pk' },
  { label: 'Palau', value: 'pw' },
  { label: 'Palestine (‫فلسطين‬‎)', value: 'ps' },
  { label: 'Panama (Panamá)', value: 'pa' },
  { label: 'Papua New Guinea', value: 'pg' },
  { label: 'Paraguay', value: 'py' },
  { label: 'Peru (Perú)', value: 'pe' },
  { label: 'Philippines', value: 'ph' },
  { label: 'Pitcairn Islands', value: 'pn' },
  { label: 'Poland (Polska)', value: 'pl' },
  { label: 'Portugal', value: 'pt' },
  { label: 'Puerto Rico', value: 'pr' },
  { label: 'Qatar (‫قطر‬‎)', value: 'qa' },
  { label: 'Réunion (La Réunion)', value: 're' },
  { label: 'Romania (România)', value: 'ro' },
  { label: 'Russia (Россия)', value: 'ru' },
  { label: 'Rwanda', value: 'rw' },
  { label: 'Saint Barthélemy (Saint-Barthélemy)', value: 'bl' },
  { label: 'Saint Helena', value: 'sh' },
  { label: 'Saint Kitts and Nevis', value: 'kn' },
  { label: 'Saint Lucia', value: 'lc' },
  { label: 'Saint Martin (Saint-Martin (partie française))', value: 'mf' },
  {
    label: 'Saint Pierre and Miquelon (Saint-Pierre-et-Miquelon)',
    value: 'pm',
  },
  { label: 'Saint Vincent and the Grenadines', value: 'vc' },
  { label: 'Samoa', value: 'ws' },
  { label: 'San Marino', value: 'sm' },
  { label: 'São Tomé and Príncipe (São Tomé e Príncipe)', value: 'st' },
  { label: 'Saudi Arabia (‫المملكة العربية السعودية‬‎)', value: 'sa' },
  { label: 'Senegal (Sénégal)', value: 'sn' },
  { label: 'Serbia (Србија)', value: 'rs' },
  { label: 'Seychelles', value: 'sc' },
  { label: 'Sierra Leone', value: 'sl' },
  { label: 'Singapore', value: 'sg' },
  { label: 'Sint Maarten', value: 'sx' },
  { label: 'Slovakia (Slovensko)', value: 'sk' },
  { label: 'Slovenia (Slovenija)', value: 'si' },
  { label: 'Solomon Islands', value: 'sb' },
  { label: 'Somalia (Soomaaliya)', value: 'so' },
  { label: 'South Africa', value: 'za' },
  { label: 'South Georgia & South Sandwich Islands', value: 'gs' },
  { label: 'South Korea (대한민국)', value: 'kr' },
  { label: 'South Sudan (‫جنوب السودان‬‎)', value: 'ss' },
  { label: 'Spain (España)', value: 'es' },
  { label: 'Sri Lanka (ශ්‍රී ලංකා)', value: 'lk' },
  { label: 'Sudan (‫السودان‬‎)', value: 'sd' },
  { label: 'Suriname', value: 'sr' },
  { label: 'Svalbard and Jan Mayen (Svalbard og Jan Mayen)', value: 'sj' },
  { label: 'Swaziland', value: 'sz' },
  { label: 'Sweden (Sverige)', value: 'se' },
  { label: 'Switzerland (Schweiz)', value: 'ch' },
  { label: 'Syria (‫سوريا‬‎)', value: 'sy' },
  { label: 'Taiwan (台灣)', value: 'tw' },
  { label: 'Tajikistan', value: 'tj' },
  { label: 'Tanzania', value: 'tz' },
  { label: 'Thailand (ไทย)', value: 'th' },
  { label: 'Timor-Leste', value: 'tl' },
  { label: 'Togo', value: 'tg' },
  { label: 'Tokelau', value: 'tk' },
  { label: 'Tonga', value: 'to' },
  { label: 'Trinidad and Tobago', value: 'tt' },
  { label: 'Tunisia (‫تونس‬‎)', value: 'tn' },
  { label: 'Turkey (Türkiye)', value: 'tr' },
  { label: 'Turkmenistan (Türkmenistan)', value: 'tm' },
  { label: 'Turks and Caicos Islands', value: 'tc' },
  { label: 'Tuvalu', value: 'tv' },
  { label: 'U.S. Virgin Islands', value: 'vi' },
  { label: 'Uganda', value: 'ug' },
  { label: 'Ukraine (Україна)', value: 'ua' },
  { label: 'United Arab Emirates (‫الإمارات العربية المتحدة‬‎)', value: 'ae' },
  { label: 'United Kingdom', value: 'gb' },
  { label: 'United States', value: 'us' },
  { label: 'Uruguay', value: 'uy' },
  { label: 'Uzbekistan (Oʻzbekiston)', value: 'uz' },
  { label: 'Vanuatu', value: 'vu' },
  { label: 'Vatican City (Città del Vaticano)', value: 'va' },
  { label: 'Venezuela', value: 've' },
  { label: 'Vietnam (Việt Nam)', value: 'vn' },
  { label: 'Wallis and Futuna', value: 'wf' },
  { label: 'Western Sahara (‫الصحراء الغربية‬‎)', value: 'eh' },
  { label: 'Yemen (‫اليمن‬‎)', value: 'ye' },
  { label: 'Zambia', value: 'zm' },
  { label: 'Zimbabwe', value: 'zw' },
];

// 日本語版
export const COUNTRY_LIST_JP = [
  { label: 'アフガニスタン', value: 'af' },
  { label: 'オーランド諸島 (Åland)', value: 'ax' },
  { label: 'アルバニア (Shqipëri)', value: 'al' },
  { label: 'アルジェリア (الجزائر)', value: 'dz' },
  { label: 'アメリカ領サモア', value: 'as' },
  { label: 'アンドラ', value: 'ad' },
  { label: 'アンゴラ', value: 'ao' },
  { label: 'アンギラ', value: 'ai' },
  { label: '南極', value: 'aq' },
  { label: 'アンチグア・バーブーダ', value: 'ag' },
  { label: 'アルゼンチン', value: 'ar' },
  { label: 'アルメニア (Հայաստան)', value: 'am' },
  { label: 'アルバ', value: 'aw' },
  { label: 'オーストラリア', value: 'au' },
  { label: 'オーストリア (Österreich)', value: 'at' },
  { label: 'アゼルバイジャン (Azərbaycan)', value: 'az' },
  { label: 'バハマ', value: 'bs' },
  { label: 'バーレーン (البحرين)', value: 'bh' },
  { label: 'バングラデシュ (বাংলাদেশ)', value: 'bd' },
  { label: 'バルバドス', value: 'bb' },
  { label: 'ベラルーシ (Беларусь)', value: 'by' },
  { label: 'ベルギー (België)', value: 'be' },
  { label: 'ベリーズ', value: 'bz' },
  { label: 'ベナン (Bénin)', value: 'bj' },
  { label: 'バミューダ', value: 'bm' },
  { label: 'ブータン (འབྲུག)', value: 'bt' },
  { label: 'ボリビア', value: 'bo' },
  { label: 'ボスニア・ヘルツェゴビナ (BiH)', value: 'ba' },
  { label: 'ボツワナ', value: 'bw' },
  { label: 'ブラジル (Brasil)', value: 'br' },
  { label: '英領インド洋地域', value: 'io' },
  { label: '英領ヴァージン諸島', value: 'vg' },
  { label: 'ブルネイ (Negara Brunei Darussalam)', value: 'bn' },
  { label: 'ブルガリア (България)', value: 'bg' },
  { label: 'ブルキナファソ', value: 'bf' },
  { label: 'ブルンジ (Uburundi)', value: 'bi' },
  { label: 'カンボジア (កម្ពុជា)', value: 'kh' },
  { label: 'カメルーン (Cameroun)', value: 'cm' },
  { label: 'カナダ', value: 'ca' },
  { label: 'カーボベルデ (Kabu Verdi)', value: 'cv' },
  { label: 'カリブオランダ', value: 'bq' },
  { label: 'ケイマン諸島', value: 'ky' },
  { label: '中央アフリカ共和国', value: 'cf' },
  { label: 'チャド (Tchad)', value: 'td' },
  { label: 'チリ', value: 'cl' },
  { label: '中国 (中国)', value: 'cn' },
  { label: 'クリスマス島', value: 'cx' },
  { label: 'ココス(キーリング)諸島', value: 'cc' },
  { label: 'コロンビア', value: 'co' },
  { label: 'コモロ (جزر القمر)', value: 'km' },
  { label: 'コンゴ民主共和国 (旧ザイール)', value: 'cd' },
  { label: 'コンゴ共和国', value: 'cg' },
  { label: 'クック諸島', value: 'ck' },
  { label: 'コスタリカ', value: 'cr' },
  { label: 'コートジボワール', value: 'ci' },
  { label: 'クロアチア (Hrvatska)', value: 'hr' },
  { label: 'キューバ', value: 'cu' },
  { label: 'キュラソー', value: 'cw' },
  { label: 'キプロス (Κύπρος)', value: 'cy' },
  { label: 'チェコ (Česká republika)', value: 'cz' },
  { label: 'デンマーク (Danmark)', value: 'dk' },
  { label: 'ジブチ', value: 'dj' },
  { label: 'ドミニカ国', value: 'dm' },
  { label: 'ドミニカ共和国 (República Dominicana)', value: 'do' },
  { label: 'エクアドル', value: 'ec' },
  { label: 'エジプト (مصر)', value: 'eg' },
  { label: 'エルサルバドル', value: 'sv' },
  { label: '赤道ギニア (Guinea Ecuatorial)', value: 'gq' },
  { label: 'エリトリア', value: 'er' },
  { label: 'エストニア (Eesti)', value: 'ee' },
  { label: 'エチオピア', value: 'et' },
  { label: 'フォークランド諸島 (Islas Malvinas)', value: 'fk' },
  { label: 'フェロー諸島 (Føroyar)', value: 'fo' },
  { label: 'フィジー', value: 'fj' },
  { label: 'フィンランド (Suomi)', value: 'fi' },
  { label: 'フランス', value: 'fr' },
  { label: '仏領ギアナ (Guyane française)', value: 'gf' },
  { label: '仏領ポリネシア (Polynésie française)', value: 'pf' },
  { label: 'ガボン', value: 'ga' },
  { label: 'ガンビア', value: 'gm' },
  { label: 'ジョージア (საქართველო)', value: 'ge' },
  { label: 'ドイツ (Deutschland)', value: 'de' },
  { label: 'ガーナ (Gaana)', value: 'gh' },
  { label: 'ジブラルタル', value: 'gi' },
  { label: 'ギリシャ (Ελλάδα)', value: 'gr' },
  { label: 'グリーンランド (Kalaallit Nunaat)', value: 'gl' },
  { label: 'グレナダ', value: 'gd' },
  { label: 'グアドループ', value: 'gp' },
  { label: 'グアム', value: 'gu' },
  { label: 'グアテマラ', value: 'gt' },
  { label: 'ガーンジー島', value: 'gg' },
  { label: 'ギニア (Guinée)', value: 'gn' },
  { label: 'ギニアビサウ (Guiné Bissau)', value: 'gw' },
  { label: 'ガイアナ', value: 'gy' },
  { label: 'ハイチ', value: 'ht' },
  { label: 'ホンジュラス', value: 'hn' },
  { label: '香港 (香港)', value: 'hk' },
  { label: 'ハンガリー (Magyarország)', value: 'hu' },
  { label: 'アイスランド (Ísland)', value: 'is' },
  { label: 'インド (भारत)', value: 'in' },
  { label: 'インドネシア', value: 'id' },
  { label: 'イラン (ایران)', value: 'ir' },
  { label: 'イラク (العراق)', value: 'iq' },
  { label: 'アイルランド', value: 'ie' },
  { label: 'マン島', value: 'im' },
  { label: 'イスラエル (ישראל)', value: 'il' },
  { label: 'イタリア (Italia)', value: 'it' },
  { label: 'ジャマイカ', value: 'jm' },
  { label: '日本 (日本)', value: 'jp' },
  { label: 'ジャージー島', value: 'je' },
  { label: 'ヨルダン (الأردن)', value: 'jo' },
  { label: 'カザフスタン (Казахстан)', value: 'kz' },
  { label: 'ケニア', value: 'ke' },
  { label: 'キリバス', value: 'ki' },
  { label: 'コソボ (Kosovë)', value: 'xk' },
  { label: 'クウェート (الكويت)', value: 'kw' },
  { label: 'キルギス (Кыргызстан)', value: 'kg' },
  { label: 'ラオス (ລາວ)', value: 'la' },
  { label: 'ラトビア (Latvija)', value: 'lv' },
  { label: 'レバノン (لبنان)', value: 'lb' },
  { label: 'レソト', value: 'ls' },
  { label: 'リベリア', value: 'lr' },
  { label: 'リビア (ليبيا)', value: 'ly' },
  { label: 'リヒテンシュタイン', value: 'li' },
  { label: 'リトアニア (Lietuva)', value: 'lt' },
  { label: 'ルクセンブルク', value: 'lu' },
  { label: 'マカオ (澳門)', value: 'mo' },
  { label: '北マケドニア (Македонија)', value: 'mk' },
  { label: 'マダガスカル (Madagasikara)', value: 'mg' },
  { label: 'マラウイ', value: 'mw' },
  { label: 'マレーシア', value: 'my' },
  { label: 'モルディブ', value: 'mv' },
  { label: 'マリ', value: 'ml' },
  { label: 'マルタ', value: 'mt' },
  { label: 'マーシャル諸島', value: 'mh' },
  { label: 'マルティニーク', value: 'mq' },
  { label: 'モーリタニア (موريتانيا)', value: 'mr' },
  { label: 'モーリシャス (Moris)', value: 'mu' },
  { label: 'マイヨット', value: 'yt' },
  { label: 'メキシコ (México)', value: 'mx' },
  { label: 'ミクロネシア連邦', value: 'fm' },
  { label: 'モルドバ共和国 (Republica Moldova)', value: 'md' },
  { label: 'モナコ', value: 'mc' },
  { label: 'モンゴル (Монгол)', value: 'mn' },
  { label: 'モンテネグロ (Crna Gora)', value: 'me' },
  { label: 'モントセラト', value: 'ms' },
  { label: 'モロッコ (المغرب)', value: 'ma' },
  { label: 'モザンビーク (Moçambique)', value: 'mz' },
  { label: 'ミャンマー (ビルマ)', value: 'mm' },
  { label: 'ナミビア', value: 'na' },
  { label: 'ナウル', value: 'nr' },
  { label: 'ネパール (नेपाल)', value: 'np' },
  { label: 'オランダ (Nederland)', value: 'nl' },
  { label: 'ニューカレドニア (Nouvelle-Calédonie)', value: 'nc' },
  { label: 'ニュージーランド', value: 'nz' },
  { label: 'ニカラグア', value: 'ni' },
  { label: 'ニジェール (Nijar)', value: 'ne' },
  { label: 'ナイジェリア', value: 'ng' },
  { label: 'ニウエ', value: 'nu' },
  { label: 'ノーフォーク島', value: 'nf' },
  { label: '北朝鮮 (조선民主주의인민공화국)', value: 'kp' },
  { label: '北マリアナ諸島', value: 'mp' },
  { label: 'ノルウェー (Norge)', value: 'no' },
  { label: 'オマーン (عُمان)', value: 'om' },
  { label: 'パキスタン (پاکستان)', value: 'pk' },
  { label: 'パラオ', value: 'pw' },
  { label: 'パレスチナ (فلسطين)', value: 'ps' },
  { label: 'パナマ (Panamá)', value: 'pa' },
  { label: 'パプアニューギニア', value: 'pg' },
  { label: 'パラグアイ', value: 'py' },
  { label: 'ペルー (Perú)', value: 'pe' },
  { label: 'フィリピン', value: 'ph' },
  { label: 'ピトケアン諸島', value: 'pn' },
  { label: 'ポーランド (Polska)', value: 'pl' },
  { label: 'ポルトガル', value: 'pt' },
  { label: 'プエルトリコ', value: 'pr' },
  { label: 'カタール (قطر)', value: 'qa' },
  { label: 'レユニオン (La Réunion)', value: 're' },
  { label: 'ルーマニア (România)', value: 'ro' },
  { label: 'ロシア (Россия)', value: 'ru' },
  { label: 'ルワンダ', value: 'rw' },
  { label: 'サン・バルテルミー', value: 'bl' },
  { label: 'セントヘレナ', value: 'sh' },
  { label: 'セントクリストファー・ネイビス', value: 'kn' },
  { label: 'セントルシア', value: 'lc' },
  { label: 'サン・マルタン（フランス領）', value: 'mf' },
  { label: 'サンピエール島・ミクロン島', value: 'pm' },
  { label: 'セントビンセントおよびグレナディーン諸島', value: 'vc' },
  { label: 'サモア', value: 'ws' },
  { label: 'サンマリノ', value: 'sm' },
  { label: 'サントメ・プリンシペ (São Tomé e Príncipe)', value: 'st' },
  { label: 'サウジアラビア (المملكة العربية السعودية)', value: 'sa' },
  { label: 'セネガル (Sénégal)', value: 'sn' },
  { label: 'セルビア (Србија)', value: 'rs' },
  { label: 'セーシェル', value: 'sc' },
  { label: 'シエラレオネ', value: 'sl' },
  { label: 'シンガポール', value: 'sg' },
  { label: 'シント・マールテン（オランダ領）', value: 'sx' },
  { label: 'スロバキア (Slovensko)', value: 'sk' },
  { label: 'スロベニア (Slovenija)', value: 'si' },
  { label: 'ソロモン諸島', value: 'sb' },
  { label: 'ソマリア (Soomaaliya)', value: 'so' },
  { label: '南アフリカ', value: 'za' },
  { label: 'サウスジョージア・サウスサンドウィッチ諸島', value: 'gs' },
  { label: '韓国 (대한민국)', value: 'kr' },
  { label: '南スーダン (جنوب السودان)', value: 'ss' },
  { label: 'スペイン (España)', value: 'es' },
  { label: 'スリランカ (ශ්‍රී ලංකා)', value: 'lk' },
  { label: 'スーダン (السودان)', value: 'sd' },
  { label: 'スリナム', value: 'sr' },
  { label: 'スヴァールバル諸島およびヤンマイエン島', value: 'sj' },
  { label: 'エスワティニ (旧スワジランド)', value: 'sz' },
  { label: 'スウェーデン (Sverige)', value: 'se' },
  { label: 'スイス (Schweiz)', value: 'ch' },
  { label: 'シリア (سوريا)', value: 'sy' },
  { label: '台湾 (台灣)', value: 'tw' },
  { label: 'タジキスタン', value: 'tj' },
  { label: 'タンザニア', value: 'tz' },
  { label: 'タイ (ไทย)', value: 'th' },
  { label: '東ティモール (Timor-Leste)', value: 'tl' },
  { label: 'トーゴ', value: 'tg' },
  { label: 'トケラウ', value: 'tk' },
  { label: 'トンガ', value: 'to' },
  { label: 'トリニダード・トバゴ', value: 'tt' },
  { label: 'チュニジア (تونس)', value: 'tn' },
  { label: 'トルコ (Türkiye)', value: 'tr' },
  { label: 'トルクメニスタン (Türkmenistan)', value: 'tm' },
  { label: 'タークス・カイコス諸島', value: 'tc' },
  { label: 'ツバル', value: 'tv' },
  { label: '米領ヴァージン諸島', value: 'vi' },
  { label: 'ウガンダ', value: 'ug' },
  { label: 'ウクライナ (Україна)', value: 'ua' },
  { label: 'アラブ首長国連邦 (الإمارات العربية المتحدة)', value: 'ae' },
  { label: 'イギリス', value: 'gb' },
  { label: 'アメリカ合衆国', value: 'us' },
  { label: 'ウルグアイ', value: 'uy' },
  { label: 'ウズベキスタン (Oʻzbekiston)', value: 'uz' },
  { label: 'バヌアツ', value: 'vu' },
  { label: 'バチカン市国 (Città del Vaticano)', value: 'va' },
  { label: 'ベネズエラ', value: 've' },
  { label: 'ベトナム (Việt Nam)', value: 'vn' },
  { label: 'ウォリス・フツナ', value: 'wf' },
  { label: '西サハラ (الصحراء الغربية)', value: 'eh' },
  { label: 'イエメン (اليمن)', value: 'ye' },
  { label: 'ザンビア', value: 'zm' },
  { label: 'ジンバブエ', value: 'zw' },
];
